/* eslint-disable */

import { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import jsonToFormData from 'json-form-data';
import styled from 'styled-components';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { css } from 'styled-components';

import FormikValidator from './FormikValidator';
import { ActionsWrapper, InputWrapper } from './StyledComponents';
import ColorPicker from '../../../../shared/ColorPicker';
import { Wrapper, Title } from '../../../../shared/ModalComponents';
import Select from '../../../../shared/Select';
import CreatableSelect from '../../../../shared/CreatableSelect';
import { BaseInput, Label as BaseLabel } from '../../../../shared/FormStyles';
import { Button } from '../../../../shared/FormStyles/Button';
import CampaignDates from '../ClientsDashboard/CampaignDates.jsx';
import FileInput from '../../../../shared/FileInput';
import { useGetClientsList } from '../../data';
import defaultAttrs from '../../../../lib/utils/defaultAttrs';

const Airbo = window.Airbo || {};

const popoverStyle = css`
  top: auto !important;
  left: auto !important;
  bottom: 135px !important;
  right: -130px !important;
  z-index: 999;
`;

const formInitialValues = {
  demo: {
    demo_type_id: '',
    client_name: '',
    demo_name: '',
    eligible_employees: '',
    logo: '',
    primary_color: '',
    begins_at: '',
    ends_at: '',
  },
};

const NewVbfBoardForm = ({
  templateList,
  handleCancel,
  mutate,
  isEdit,
  editValues,
}) => {
  const { t } = useTranslation('clients');

  const [validLogo, setValidLogo] = useState(true);
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateInputValue, setDateInputValue] = useState('');
  const [colorPickerNode, setColorPickerNode] = useState(null);

  const { clients } = useGetClientsList();

  function validateLogo(value) {
    const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];

    if (SUPPORTED_FORMATS.includes(value.type)) {
      setValidLogo(true);
      return true;
    }
    setValidLogo(false);
    return false;
  }

  function formatCalendarField() {
    if (editValues.begins_at !== null) {
      const beginDate = moment(editValues['begins_at']).format('MM/DD/YYYY');
      const endDate = moment(editValues['ends_at']).format('MM/DD/YYYY');
      setDateInputValue(`${beginDate} - ${endDate}`);
    }
  }

  function formatEditValues(formik) {
    if (isEdit) {
      const fields = [
        'client_name',
        'demo_name',
        'eligible_employees',
        'begins_at',
        'ends_at',
        'primary_color',
        'id',
      ];
      fields.forEach(field =>
        formik.setFieldValue(`demo[${field}]`, editValues[field]),
      );
      formatCalendarField();
    }
  }

  const editValidation = {
    client_name: Yup.string().required(),
    demo_name: Yup.string().required(),
    eligible_employees: Yup.number()
      .moreThan(0)
      .required(),
    logo: Yup.mixed().test('fileType', '', value => {
      return value ? validateLogo(value) : true;
    }),
  };

  const createValidation = {
    demo_type_id: Yup.string().required(),
    client_name: Yup.string().required(),
    demo_name: Yup.string().required(),
    eligible_employees: Yup.number()
      .moreThan(0)
      .required(),
    logo: Yup.mixed().test('fileType', '', value => {
      return value ? validateLogo(value) : true;
    }),
  };

  const validationSchema = Yup.object({
    demo: Yup.object(isEdit ? editValidation : createValidation),
  });

  const templateSelectList = templateList.map(template => ({
    value: template.id,
    label: template.name,
  }));

  const clientSelectList = clients.length
    ? clients.map(client => ({
        value: client.name,
        label: client.name,
      }))
    : [];

  const submitEventPing = values => {
    const {
      client_name,
      demo_name,
      demo_type_id,
      eligible_employees,
      primary_color,
    } = values;

    Airbo.Utils.ping('Click Save on Campaign', {
      client_name,
      demo_name,
      eligible_employees,
      primary_color,
      template_id: demo_type_id,
      tab: Airbo.Utils.currentTab(),
      organization: Airbo.Utils.currentOrganization(),
    });
  };

  return (
    <Wrapper>
      <Formik
        initialValues={formInitialValues}
        validationSchema={validationSchema}
        onSubmit={values => {
          submitEventPing(values.demo);

          const valuesTransformed = jsonToFormData(values);
          const send = { data: valuesTransformed };
          if (isEdit) send.id = values.demo.id;
          mutate(send);
        }}
      >
        {formik => {
          useEffect(() => {
            formatEditValues(formik);
          }, []);
          return (
            <Form
              className="new_demo"
              id="new_demo"
              encType="multipart/form-data"
            >
              <FormWrapper hide={showCalendar}>
                <Title>{isEdit ? t('form.edit') : t('form.new')}</Title>
                {!isEdit && (
                  <Select
                    label={t('form.campaignTemplate')}
                    id="demo_type_id"
                    name="demo[demo_type_id]"
                    onChange={option => {
                      formik.setFieldValue('demo[demo_type_id]', option.value);
                    }}
                    className="react-select"
                    placeholder={t('form.campaignTemplatePlaceholder')}
                    options={templateSelectList}
                    isSearchable={false}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    value={templateSelectList.find(
                      value => value === formik.values.demo.demo_type_id,
                    )}
                  />
                )}
                <CreatableSelect
                  isClearable={true}
                  isSearchable={true}
                  id="client_name"
                  name="demo[client_name]"
                  label={t('form.client')}
                  className="react-select"
                  placeholder={t('form.clientPlaceholder')}
                  value={clientSelectList.find(
                    clientOption =>
                      clientOption.value === formik.values.demo.client_name,
                  )}
                  onChange={option => {
                    formik.setFieldValue(
                      'demo[client_name]',
                      option ? option.value : '',
                    );
                  }}
                  options={clientSelectList}
                />
                <Label htmlFor="demo_name">{t('form.demo')}</Label>
                <Input
                  id="demo_name"
                  name="demo[demo_name]"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.demo.demo_name}
                  placeholder={t('form.demoPlaceholder')}
                />
                <Label htmlFor="demo_name">{t('form.demoName')}</Label>
                <Input
                  id="demo_eligible_employees"
                  name="demo[eligible_employees]"
                  type="number"
                  min="1"
                  onChange={formik.handleChange}
                  onInput={event =>
                    // hack to prevent the user typing '-'
                    event.target.validity.valid || (event.target.value = '')
                  }
                  value={formik.values.demo.eligible_employees}
                  placeholder={t('form.demoNamePlaceholder')}
                />
                <Label>{t('form.dates')}</Label>
                <InputWrapper onClick={() => setShowCalendar(true)}>
                  <CustomInput
                    type="text"
                    placeholder={t('form.datesPlaceholder')}
                    value={dateInputValue}
                    readOnly
                  />
                  <div style={{ margin: '0px 16px' }}>
                    <CalendarIcon inputvalue={dateInputValue} />
                  </div>
                </InputWrapper>
                <Input
                  id="demo_begins_at"
                  name="demo[demo_begins_at]"
                  type="hidden"
                  onChange={formik.handleChange}
                  value={formik.values.demo.begins_at}
                />
                <Input
                  id="demo_ends_at"
                  name="demo[demo_ends_at]"
                  type="hidden"
                  onChange={formik.handleChange}
                  value={formik.values.demo.ends_at}
                />
                <div style={{ marginTop: '16px' }}>
                  <FileInput
                    id={'logo'}
                    name={'demo[logo]'}
                    fileTypes={'image/jpg,image/jpeg,image/png'}
                    fileName={formik.values.demo.logo.name}
                    fileButtonColor="black.60"
                    label={t('form.logo')}
                    onChange={event => {
                      formik.setFieldValue(
                        'demo[logo]',
                        event.currentTarget.files[0],
                      );
                    }}
                    errorMessage={!validLogo ? t('form.logoError') : ''}
                  />
                </div>
                <Label htmlFor="primary_color" style={{ marginTop: 16 }}>
                  {t('form.color')}
                </Label>
                <InputWrapper>
                  <CustomInput
                    id="primary_color"
                    name="demo[primary_color]"
                    type="text"
                    onChange={event => {
                      formik.setFieldValue(
                        'demo[primary_color]',
                        event.target.value,
                      );
                    }}
                    value={formik.values.demo.primary_color}
                    placeholder="#000000"
                  />
                  <div style={{ padding: '0 8px' }} ref={setColorPickerNode}>
                    <ColorPicker
                      colorChangeHandler={color => {
                        formik.setFieldValue('demo[primary_color]', color);
                      }}
                      popoverStyle={popoverStyle}
                      portalNode={colorPickerNode}
                      initialColor={
                        isEdit ? editValues.primary_color : undefined
                      }
                    />
                  </div>
                </InputWrapper>
                <ActionsWrapper id="actions">
                  <ButtonModal
                    variant="tertiary"
                    type="button"
                    onClick={() => handleCancel()}
                  >
                    {t('form.cancel')}
                  </ButtonModal>
                  <ButtonModal
                    variant="containedBlue"
                    type="submit"
                    disabled={!formik.isValid || !formik.dirty}
                  >
                    {isEdit ? t('form.save') : t('form.create')}
                  </ButtonModal>
                </ActionsWrapper>
              </FormWrapper>
              {showCalendar && (
                <CampaignDates
                  title={isEdit ? t('form.edit') : t('form.new')}
                  onSave={(dates, inputValue) => {
                    formik.setFieldValue('demo[begins_at]', dates[0]);
                    formik.setFieldValue('demo[ends_at]', dates[1]);
                    setDateInputValue(inputValue);
                    setShowCalendar(false);
                    formik.validateForm();
                  }}
                  onCancel={() => setShowCalendar(false)}
                />
              )}
              <FormikValidator />
            </Form>
          );
        }}
      </Formik>
    </Wrapper>
  );
};

export default NewVbfBoardForm;

const CalendarIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-light fa-calendar',
  }),
)`
  color: ${props => (props.inputvalue.length > 0 ? '#007EFF' : '#CACCCF')};
`;

const FormWrapper = styled.div`
  padding: 0 11px;
  display: ${props => (props.hide ? 'none' : 'block')};
`;

const Label = styled(BaseLabel)`
  margin-bottom: 8px;
`;

const Input = styled(BaseInput)`
  margin: 0 0 16px 0 !important;
`;

const CustomInput = styled(BaseInput)`
  padding: 10px 16px !important;
  border: 0 !important;
`;

const ButtonModal = styled(Button)`
  margin-left: 16px;
  margin-bottom: 0px;
`;
